import { Box, Button, Flex, IconButton } from '@chakra-ui/react';
import { MdSend } from 'react-icons/md';
import { useState } from 'react';

import { QueryTable } from '@app/components/common/table';
import { useAlert, useApi } from '@app/hooks';
import { EquipmentRepairOrder } from '@app/api/models';

import Dialog from '../../common/modals/dialog';
import { mapInstance } from '../utils/mapInstance';
import { EquipmentsRepairFormInstance } from '../types';

export const SendModal = ({
  variant = 'icon',
  needSave,
  id,
  order,
  onClose,
  onSuccess,
}: {
  variant?: 'icon' | 'button';
  id: string;
  order: Partial<EquipmentsRepairFormInstance>;
  needSave?: boolean;
  onClose?(): void;
  onSuccess?(): void;
}) => {
  const api = useApi();
  const [isOpen, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { refetch } = QueryTable.useQueryTable();
  const { info, error } = useAlert();

  const send = async () => {
    if (!order.service_data?.inventory_num) {
      error('В заявке не заполнены обязательные поля: Не указан инвентарный номер');
      return;
    }
    try {
      setLoading(true);
      if (needSave) {
        const saveResponse = await api.equipments.putEquipmentsRepair(mapInstance(order)); 
        if (saveResponse.code === 200) {
          info(saveResponse.message);
        } else {
          error(`Ошибка при отправке заявки: ${saveResponse.data.message}`);
        }
      }


      const response = await api.equipments.sendEquipmentsRepair('' + id);
      if (response.code === 200) {
        info(response.message);
      } else {
        error(`Ошибка при отправке заявки: ${response.data.message}`);
      }
      onSuccess?.();
      refetch?.();
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
      setOpen(false);
      onClose?.();
    }
  };

  return (
    <>
      {variant === 'icon' && <IconButton onClick={() => setOpen(true)} isLoading={loading} aria-label="status-edit">
        <MdSend />
      </IconButton>}
      {variant === 'button' && <Button colorScheme={needSave ? 'green' : 'brand'} variant='outline' onClick={() => setOpen(true)} isLoading={loading} aria-label="status-edit">
        {needSave ? 'Сохранить и отправить' : 'Отправить'}
      </Button>}
      <Dialog
        open={isOpen}
        onClose={() => setOpen(false)}
        title="Отправить заявку"
        actions={
          <Flex justifyContent="space-between" flex={1}>
            <Button colorScheme='brand'  onClick={send}>Отправить</Button>
            <Button variant='ghost' onClick={() => setOpen(false)}>Отмена</Button>
          </Flex>
        }
        loading={loading}
      >
        <Box >Отправить заявку в сервисную организацию?</Box>
      </Dialog>
    </>
  );
};
